module.exports = __webpack_public_path__ + "img/mesa_el_y.6bd9aa54.png";